import { MailOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { Link as RouterLink } from 'react-router-dom';

export const LandingFooter: React.FC = () => {
  return (
    <footer className="landing-footer">
      <div className="landing-footer-content">
        <div className="landing-footer-brand">
          <picture>
            <source srcSet="/rongekafooter.webp" type="image/webp" />
            <img src="/rongekafooter.png" alt="Rongeka Africa" className="landing-footer-logo" width="300" height="116" />
          </picture>
          <p>
            Rongeka Africa School Management System is a powerful, all-in-one platform built for Zimbabwean
            schools to manage students, fees, accounting, and daily operations - with one full term free
            to experience the difference.
          </p>
        </div>

        <div className="landing-footer-column">
          <h4>Product</h4>
          <RouterLink to="/pricing">Pricing</RouterLink>
          <RouterLink to="/faq">FAQ</RouterLink>
          <RouterLink to="/news">News</RouterLink>
          <RouterLink to="/get-started">Get Started</RouterLink>
        </div>

        <div className="landing-footer-column">
          <h4>Features</h4>
          <RouterLink to="/features/whatsapp">WhatsApp for Schools</RouterLink>
          <RouterLink to="/features/fees">Fees Management</RouterLink>
          <RouterLink to="/features/accounting">School Accounting</RouterLink>
          <RouterLink to="/features/reports">Report Cards</RouterLink>
          <RouterLink to="/features/ecocash-payments">EcoCash Payments</RouterLink>
          <RouterLink to="/features/zimsec-exams">ZIMSEC Grading and Exams</RouterLink>
          <RouterLink to="/secondary-schools">For Secondary Schools</RouterLink>
        </div>

        <div className="landing-footer-column">
          <h4>Legal</h4>
          <RouterLink to="/terms">Terms &amp; Conditions</RouterLink>
          <RouterLink to="/privacy-policy">Privacy Policy</RouterLink>
        </div>

        <div className="landing-footer-column">
          <h4>Support</h4>
          <RouterLink to="/about">About Us</RouterLink>
          <RouterLink to="/contact">Contact</RouterLink>
          <a href="mailto:support@rongeka.africa">
            <MailOutlined /> support@rongeka.africa
          </a>
          <a href="https://wa.me/263789442202" target="_blank" rel="noopener noreferrer">
            <WhatsAppOutlined /> +263 78 944 2202
          </a>
        </div>
      </div>

      <div className="landing-footer-bottom">
        <p suppressHydrationWarning>&copy; {new Date().getFullYear()} Rongeka Africa. All rights reserved.</p>
      </div>
    </footer>
  );
};
